import SVG_LOADING from '../assets/images/ai-loading.json';
import Lottie from 'react-lottie';

export function AILoadingBlocker({children}) {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: SVG_LOADING,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  
  return (
    <div className="blocker">
      <div className="backdrop"></div>
      <div className="foreground">
          <div className="bg-black w-[220px] rounded-[20px] p-[28px]">
              <Lottie options={defaultOptions} width={100} height={100}></Lottie>
              {children}
          </div>
      </div>
    </div>
  )
}